module.exports = __webpack_public_path__ + "img/discounts.104a04b7.svg";